// Populated at container startup (see docker/40-render-env-config.sh) from
// SERVER_ADDRESS/LIVEKIT_URL env vars - same image, different deploys. Empty
// in dev (public/env-config.js placeholder), so the localhost defaults apply.
const runtimeConfig = (typeof window !== 'undefined' && window.__CYCLONE_CONFIG__) || {};

export const server_address = runtimeConfig.SERVER_ADDRESS || 'http://localhost:4000/';
export const livekit_url = runtimeConfig.LIVEKIT_URL || 'ws://localhost:7880';

// The path the SPA is mounted under - see package.json's `homepage` and the
// <Router basename> in App.js, which must stay in agreement with it. Exported
// because meeting links (MeetingAPI.meetingLink) are built by hand rather than
// by react-router, and a link that skips the basename 404s.
export const router_basename = '/cyclone';
